/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';


export default class Ladder extends Logic
{
  getTerritoryScores ()
  {
    return this.getScores('territory');
  }


  getAuthorityScores ()
  {
    return this.getScores('authority');
  }


  getValueScores ()
  {
    return this.getScores('value');
  }


  getScoresAround (field, user)
  {
    const scores = this.getScores(field);

    const index = scores.findIndex(entry => entry.user === user);

    const start = Math.max(0, Math.min(index - 1, scores.length - 3));

    return scores.slice(start, start + 3);
  }


  getScores (field)
  {
    const entries = this.object.getScores().values().map(score =>
    {
      const { id, name, theme } = score.cass;

      return { user: id, name, theme, value: score.cass[field] };
    });

    entries.sort((one, two) =>
    {
      return two.value - one.value;
    });

    return entries.reduce((scores, entry) =>
    {
      const previous = scores[scores.length - 1];

      const rank = previous?.value === entry.value ? previous.rank : (previous?.rank ?? 0) + 1;

      scores.push({ rank, ...entry });

      return scores;
    }, []);
  }


};
